"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CreditsIcon = function CreditsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M.2 5.5a5.285 5.285 0 0 1 10.358-1.497c-.02 0-.038-.003-.058-.003a6.49 6.49 0 0 0-.96.079 4.289 4.289 0 1 0-5.46 5.46A6.49 6.49 0 0 0 4 10.5c0 .02.003.039.003.058A5.29 5.29 0 0 1 .2 5.5zm4.095 3.064a6.446 6.446 0 0 1 .377-.924A2.298 2.298 0 0 1 3.2 5.5h-1a3.3 3.3 0 0 0 2.095 3.064zM5.5 4.2a1.283 1.283 0 0 1 1.24 1.007 6.502 6.502 0 0 1 .9-.535A2.296 2.296 0 0 0 3.2 5.5h1a1.301 1.301 0 0 1 1.3-1.3zm10.3 6.3a5.3 5.3 0 1 1-5.3-5.3 5.306 5.306 0 0 1 5.3 5.3zm-5.3-4.3a4.3 4.3 0 1 0 4.3 4.3 4.304 4.304 0 0 0-4.3-4.3zm0 6.6a2.302 2.302 0 0 1-2.3-2.3h-1a3.3 3.3 0 0 0 6.6 0h-1a2.302 2.302 0 0 1-2.3 2.3zm0-4.6a2.302 2.302 0 0 0-2.3 2.3h1a1.3 1.3 0 0 1 2.6 0h1a2.302 2.302 0 0 0-2.3-2.3z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7 15.5c0 .049.006.096.007.145a7.3 7.3 0 1 1 8.638-8.638c-.049 0-.096-.007-.145-.007a8.557 8.557 0 0 0-.877.045 6.296 6.296 0 1 0-7.578 7.578A8.557 8.557 0 0 0 7 15.5zM8.5 4A4.505 4.505 0 0 0 4 8.5h-.8a5.297 5.297 0 0 0 4.016 5.124 8.396 8.396 0 0 1 .28-.955A4.299 4.299 0 0 1 4.2 8.5H5a3.5 3.5 0 0 1 6.929-.703 8.434 8.434 0 0 1 .927-.37A4.498 4.498 0 0 0 8.5 4zm14.3 11.5a7.3 7.3 0 1 1-7.3-7.3 7.308 7.308 0 0 1 7.3 7.3zm-1 0a6.3 6.3 0 1 0-6.3 6.3 6.307 6.307 0 0 0 6.3-6.3zm-1 0a5.3 5.3 0 0 1-10.6 0h.8a4.5 4.5 0 0 1 9 0zm-1 0H19a3.5 3.5 0 0 0-7 0h-.8a4.3 4.3 0 0 0 8.6 0z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 20.5c0 .057.008.112.009.169a9.294 9.294 0 1 1 10.66-10.66c-.057-.001-.112-.009-.169-.009-.282 0-.56.02-.836.042a8.296 8.296 0 1 0-9.622 9.622A10.49 10.49 0 0 0 10 20.5zm1.5-15.3a6.3 6.3 0 0 0-6.3 6.3h-1a7.298 7.298 0 0 0 5.97 7.173q.088-.497.222-.977A6.306 6.306 0 0 1 5.2 11.5h1a5.289 5.289 0 0 1 10.52-.785q.478-.185.977-.323A6.297 6.297 0 0 0 11.5 5.2zm18.3 15.3a9.3 9.3 0 1 1-9.3-9.3 9.31 9.31 0 0 1 9.3 9.3zm-1 0a8.3 8.3 0 1 0-8.3 8.3 8.31 8.31 0 0 0 8.3-8.3zm-1 0a7.3 7.3 0 0 1-14.6 0h1a6.3 6.3 0 0 1 12.6 0zm-1 0h-1a5.3 5.3 0 0 0-10.6 0h-1a6.3 6.3 0 0 0 12.6 0z"
  }));
};

var _default = CreditsIcon;
exports["default"] = _default;